module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.collapsible) ? _c('div', {
    staticClass: "text-center dropdown-block",
    on: {
      "click": _vm.toggle
    }
  }, [(_vm.collapsed) ? _c('span', [_c('i', {
    staticClass: "el-icon-caret-top"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "table-cell",
      "vertical-align": "middle"
    }
  }, [_vm._v("Hide related interaction")])]) : _c('span', [_c('i', {
    staticClass: "el-icon-caret-bottom"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "table-cell",
      "vertical-align": "middle"
    }
  }, [_vm._v("View related interaction")])])]) : _vm._e(), _vm._v(" "), _c('el-collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.collapsible || _vm.collapsed),
      expression: "!collapsible || collapsed"
    }],
    staticClass: "feed-element"
  }, [_c('div', {
    staticClass: "interaction-avatar pull-left"
  }, [(_vm.interaction.ore.profile_image) ? _c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": _vm.interaction.ore.profile_image[0].value
    },
    on: {
      "error": function($event) {
        return _vm.imageLoadOnError()
      }
    }
  }) : _c('i', {
    staticClass: "fa fa-user-circle fa-3x"
  }), _vm._v(" "), _c('div', {
    staticClass: "interaction-type img-circle",
    class: _vm.interaction.type
  }, [_c('i', {
    staticClass: "fa fa-sm",
    class: _vm.iconClasses[_vm.interaction.type]
  })])]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('small', {
    staticClass: "text-muted pull-right interaction-date"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.interaction.date_created, 'HH:MM Do MMM YYYY ')))]), _vm._v(" "), _c('div', {
    staticClass: "interaction-originator"
  }, [_vm._v(_vm._s(_vm.interaction.ore.originators[0].value))]), _vm._v(" "), (_vm.mediaExists) ? _c('div', {
    staticClass: "interaction-media"
  }, [(_vm.interaction.ore.image) ? _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.getMediaValue(_vm.interaction, 'image')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.interaction.ore.video) ? _c('video', {
    attrs: {
      "src": _vm.getMediaValue(_vm.interaction, 'video'),
      "controls": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.interaction.ore.audio) ? _c('audio', {
    attrs: {
      "src": _vm.getMediaValue(_vm.interaction, 'audio'),
      "controls": ""
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "interaction-message"
  }, [_vm._v(_vm._s(_vm.interaction.ore.message[0].value))])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38d161f9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/interaction/ParentInteraction.vue
// module id = 3224
// module chunks = 3